export default __webpack_public_path__ + "static/media/hörtest-avatar-02.3a04c5a6.svg";